import { getLaunchDarklyFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'
import { NotificationChannel } from '../notification-channel'
import { NotificationChannelImpl } from './notification-channel'
import { WebSocketNotificationHandlerFactory } from './websocket-notification-handler'
import type { NotificationChannel as INotificationChannel } from './model'

export const createNotificationChannel = (externalUserKey: string): INotificationChannel => {
  if (getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_NOTIFICATION_CHANNEL_V2)) {
    return new NotificationChannelImpl(WebSocketNotificationHandlerFactory, externalUserKey)
  }
  return new NotificationChannel(externalUserKey)
}
